import { z } from 'zod';

export const narrativeSectionKeySchema = z.enum([
  'cooking-up',
  'data-world',
  'website',
  'outstanding-needs',
  'feedback',
  'upcoming-meetings',
]);

export type NarrativeSectionKey = z.infer<typeof narrativeSectionKeySchema>;

export const narrativeBlockSchema = z.object({
  sectionKey: narrativeSectionKeySchema,
  richText: z.string(),
  updatedAt: z.string().nullish(),
});

export type NarrativeBlock = z.infer<typeof narrativeBlockSchema>;
